import { render } from "./ButtonLinkAdd.vue?vue&type=template&id=7ddd4532"
import script from "./ButtonLinkAdd.vue?vue&type=script&lang=js"
export * from "./ButtonLinkAdd.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__